import _ from 'lodash';
import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectBuyDowns = createSelector(getProgramsCategory, ({ buyDowns }) => buyDowns);

export const selectBuyDownsValues = createSelector(selectBuyDowns, buyDowns =>
  _.map(buyDowns, buyDown => ({ ...buyDown, value: buyDown.id })),
);

export const selectGlobalBuyDowns = createSelector(selectBuyDownsValues, buyDowns =>
  buyDowns.filter(({ isGlobal }) => isGlobal),
);

export const selectLocalBuyDowns = createSelector(selectBuyDownsValues, buyDowns =>
  buyDowns.filter(({ isGlobal }) => !isGlobal),
);
